<div class="drawer-item-wrap">
    <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
        <div class="drawer-item-content">
            <img src="./assets/img/websites/lpc-{{ extendedWidget()?.name }}-icon.svg" alt="lpc-widget-icon" />

            <div class="text-wrapper">
                <div class="text-item">{{ extendedWidget()?.label | translate }}</div>
                <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
            </div>

            <div class="info-label-container">
                @if (hideOnDesktop() || hideOnMobile() || hideOnTablet()) {
                    <div class="info-label" [tooltip]="tooltip" [tooltipAppendToBody]="true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_10364_21164)">
                                <path
                                    d="M14.2928 0.292893C14.6833 -0.0976307 15.3164 -0.097631 15.7069 0.292893C16.0973 0.683424 16.0974 1.31646 15.7069 1.70696L10.995 6.41789C11.2445 6.88999 11.3866 7.42811 11.3866 7.99992C11.3865 9.87217 9.87209 11.3866 7.99985 11.3866C7.42804 11.3866 6.88992 11.2446 6.41782 10.995L1.70688 15.707C1.31637 16.0973 0.683295 16.0974 0.292816 15.707C-0.0976567 15.3165 -0.0975541 14.6834 0.292816 14.2929L2.5145 12.0702C1.99006 11.5401 1.51 10.935 1.08286 10.2636C0.656316 9.59464 0.476476 8.76537 0.47641 7.99699C0.47641 7.22835 0.656055 6.39857 1.08286 5.72942C2.74409 3.11821 5.22252 1.48039 7.99985 1.48039C9.4005 1.48041 10.7365 1.8998 11.9276 2.65715L14.2928 0.292893ZM13.535 5.42375C14.0005 5.12663 14.6187 5.26301 14.9159 5.72844C15.3431 6.39775 15.5233 7.228 15.5233 7.99699C15.5232 8.76545 15.3435 9.5946 14.9168 10.2636C13.2556 12.8747 10.7771 14.5136 7.99985 14.5136C7.40512 14.5136 6.81909 14.4376 6.24985 14.2909C5.71541 14.153 5.39363 13.6077 5.5311 13.0732C5.66893 12.5384 6.21504 12.2166 6.74985 12.3544C7.15855 12.4597 7.57642 12.5136 7.99985 12.5136C9.92895 12.5136 11.8373 11.3778 13.2293 9.18938L13.2303 9.1884C13.403 8.91778 13.5232 8.48772 13.5233 7.99699C13.5233 7.50603 13.4031 7.0753 13.2303 6.80461C12.9332 6.3391 13.0695 5.72092 13.535 5.42375ZM7.99985 3.48039C6.07071 3.48039 4.16246 4.61518 2.77036 6.80363L2.76938 6.80461C2.5966 7.0753 2.47641 7.50599 2.47641 7.99699C2.47648 8.48778 2.59667 8.91778 2.76938 9.1884L2.77036 9.18938C3.12448 9.74609 3.51397 10.2359 3.92856 10.6562L5.00375 9.58098C4.75454 9.10914 4.61314 8.57129 4.61313 7.99992C4.61313 6.12764 6.12756 4.61321 7.99985 4.61321C8.57122 4.61321 9.10907 4.75462 9.5809 5.00383L10.4666 4.11809C9.67924 3.69571 8.846 3.48041 7.99985 3.48039Z"
                                    fill="currentColor"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_10364_21164">
                                    <rect width="16" height="16" fill="currentColor" />
                                </clipPath>
                            </defs>
                        </svg>
                        <ng-template #tooltip>
                            {{ "control_widget_hidden_on" | translate }}
                            @if (hideOnMobile()) {
                                <span>
                                    {{ "widget_hidden_mobile" | translate }}
                                    @if (hideOnTablet()) {
                                        <span>, </span>
                                    }
                                </span>
                            }
                            @if (hideOnTablet()) {
                                <span>
                                    {{ "widget_hidden_tablet" | translate }}
                                    @if (hideOnDesktop()) {
                                        <span>, </span>
                                    }
                                </span>
                            }
                            @if (hideOnDesktop()) {
                                <span>
                                    {{ "widget_hidden_desktop" | translate }}
                                </span>
                            }
                        </ng-template>
                    </div>
                }
            </div>
        </div>
    </div>
    <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
        <button
            dropdownToggle
            type="button"
            class="btn btn-action dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sp-icon icon-ellipsis"></span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li role="menuitem" [class.disabled]="isCopyDisabled() || productWidgetRestricted()">
                <a class="dropdown-item" (click)="copyWidget()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            @if (isZeroWidget()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="hideOnDesktopChange(!hideOnDesktop())">
                        <img
                            class="list-icon"
                            [src]="
                                hideOnDesktop()
                                    ? './assets/img/websites/lpc-desktop-show-icon.svg'
                                    : './assets/img/websites/lpc-desktop-hide-icon.svg'
                            "
                        />
                        {{ (hideOnDesktop() ? "control_show_on_desktop" : "control_hide_on_desktop") | translate }}
                    </a>
                </li>
            }
            @if (isZeroWidget()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="hideOnTabletChange(!hideOnTablet())">
                        <img
                            class="list-icon"
                            [src]="
                                hideOnTablet()
                                    ? './assets/img/websites/lpc-tablet-show-icon.svg'
                                    : './assets/img/websites/lpc-tablet-hide-icon.svg'
                            "
                        />
                        {{ (hideOnTablet() ? "control_show_on_tablet" : "control_hide_on_tablet") | translate }}
                    </a>
                </li>
            }
            @if (isZeroWidget()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="hideOnMobileChange(!hideOnMobile())">
                        <img
                            class="list-icon"
                            [src]="
                                hideOnMobile()
                                    ? './assets/img/websites/lpc-mobile-show-icon.svg'
                                    : './assets/img/websites/lpc-mobile-hide-icon.svg'
                            "
                        />
                        {{ (hideOnMobile() ? "control_show_on_mobile" : "control_hide_on_mobile") | translate }}
                    </a>
                </li>
            }
            <li>
                <hr />
            </li>
            <li
                role="menuitem"
                (click)="removeWidget()"
                [class.disabled]="isDeleteDisabled() || productWidgetRestricted()"
            >
                <a>
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
